
/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    ExtendContainerProps,
    PointLike,
    $NineSlicePlane,
    $SetVisibility,
    RichTextStyleParams,
    mapProp,
    $Button,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {ComputedSignal, Store} from '@gongxigames/framework/core/fragments/store/Store';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {$RubyUIText} from '../../../JSX/RubyUIText';
import {slotStore} from '@gongxigames/framework//slotV2/globals';
import {Rectangle} from 'pixi.js';

const TEXT_NORMAL_STYLE: RichTextStyleParams = {
    fontSize: 60,
    fontWeight: 'bold',
};

const TEXT_FOCUSED_STYLE: RichTextStyleParams = {
    fontSize: 60,
    stroke: 0xFF9000,
    strokeThickness: 1,
    dropShadow: true,
    dropShadowColor: 0xFFEB74,
    dropShadowAlpha: 1,
    dropShadowDistance: 0,
    dropShadowBlur: 8,
    fontWeight: 'bold',
};

const TEXT_PRESSED_STYLE: RichTextStyleParams = {
    fontSize: 58,
    fontWeight: 'bold',
};

export type $AutoplayStartButtonProps = ExtendContainerProps<{
    disabled?: boolean;
    action?: () => void;
}>;

export type $AutoplayButtonResponsiveConfig = ComputedSignal<ResponsiveConf & {width: number;}>;

export const $AutoplayStartButton: FC<$AutoplayStartButtonProps> = (props) => {
    const height = 156;
    const bgScale = mapProp(slotStore.stage_isPortrait, isPortrait => isPortrait ? 1.0 : 0.84);
    const bgWidth = Store.computed(() => 820 / bgScale.value);
    const nineSlicePlanePosition = Store.computed(() => {
        const width = bgWidth.value;

        return [-width/2, -height/2] as PointLike;
    });
    const hitArea = Store.computed(() => {
        const width = bgWidth.value;

        return new Rectangle(-width/2, -height/2, width, height);
    });

    return <$Button
        {...props}
        name='AutoplayStartButton'
        hitArea={hitArea}
        scale={bgScale}
    >{(props) => {
            return <$SetVisibility selector={props.selector}>
                <$NineSlicePlane
                    name='normal'
                    texture='green_btn_bg_normal_sys_ui_slice'
                    slices={[0, 90]}
                    width={bgWidth}
                    height={height}
                    position={nineSlicePlanePosition}
                />
                <$RubyUIText name='normal' localeID='buttonStart' stylePreset='BASE' style={TEXT_NORMAL_STYLE}/>

                <$NineSlicePlane
                    name='focused'
                    texture='green_btn_bg_focused_sys_ui_slice'
                    slices={[0, 90]}
                    width={bgWidth}
                    height={height}
                    position={nineSlicePlanePosition}
                />
                <$RubyUIText name='focused' localeID='buttonStart' stylePreset='BASE' style={TEXT_FOCUSED_STYLE}/>

                <$NineSlicePlane
                    name='pressed'
                    texture='green_btn_bg_pressed_sys_ui_slice'
                    slices={[0, 90]}
                    width={bgWidth}
                    height={height}
                    position={nineSlicePlanePosition}
                />
                <$RubyUIText name='pressed' localeID='buttonStart' stylePreset='BASE' style={TEXT_PRESSED_STYLE}/>

                <$NineSlicePlane
                    name='disabled'
                    texture='green_btn_bg_normal_sys_ui_slice'
                    slices={[0, 90]}
                    width={bgWidth}
                    height={height}
                    position={nineSlicePlanePosition}
                />
                <$RubyUIText name='disabled' localeID='buttonStart' stylePreset='BASE' style={TEXT_NORMAL_STYLE}/>
            </$SetVisibility>;
        }}</$Button>;
};
